const GET_VUID_LOADING = 'VUID/GET_VUID_LOADING';
const GET_VUID_SUCCESS = 'VUID/GET_VUID_SUCCESS';
const GET_VUID_ERROR = 'VUID/GET_VUID_ERROR';

export { GET_VUID_LOADING, GET_VUID_SUCCESS, GET_VUID_ERROR };
